import React from 'react'

import IndividualIcon from 'assets/icons/individual-icon'
import RfpIcon from 'assets/icons/rfp-icon'
import NcgIcon from 'assets/icons/ncg-icon'
import { FormattedMessage } from 'react-intl'
import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import capitalizeString from 'utils/capitalize'
import ActionsMenu from 'features/ActionMenu'
import BlockIcon from 'assets/icons/block-icon'
import EditIcon from 'assets/icons/edit-icon'
import ApproveIcon from 'assets/icons/approve-user-icon'

import { YellowStatusDot, GreenStatusDot, IconContainer } from './style'
import { ACTIVE_USER_STATUS_ID, PENDING_USER_STATUS_ID } from 'constants/userStatuses'
import { requestApproveRole, requestDeclineRole } from 'api/user'
import { SortingArrowWrapper } from '../../components/SortingArrow/style'

export const renderStatusIcon = (status) => {
  const statusIcons = {
    active: <GreenStatusDot />,
    pending: <YellowStatusDot />
  }

  return statusIcons[status]
}

export const renderRoleIconName = (role) => {
  const rolesIcons = {
    individual: (
      <>
        <IconContainer>
          <IndividualIcon />
        </IconContainer>{' '}
        Individual
      </>
    ),
    'regional focal point': (
      <>
        <IconContainer>
          <RfpIcon />
        </IconContainer>{' '}
        RFP
      </>
    ),
    'national coordination group': (
      <>
        <IconContainer>
          <NcgIcon />
        </IconContainer>{' '}
        NCG{' '}
      </>
    )
  }

  return rolesIcons[role]
}

export const makeUserRow = (users, handleGetUserForModal, getUsers) => {
  return users.map((user) => {
    const dropdownItems = [
      {
        icon: <ApproveIcon />,
        title: 'approve',
        onClick: () => {
          requestApproveRole(user.id).then((data) => {
            console.log(data)
            getUsers()
          })
        }
      },
      {
        icon: <EditIcon />,
        title: 'manageUser',
        onClick: () => {
          handleGetUserForModal(user)
        }
      },
      {
        icon: <BlockIcon />,
        title: user.UserStatus.id === ACTIVE_USER_STATUS_ID ? 'block' : 'decline',
        onClick:
          user.UserStatus.id === ACTIVE_USER_STATUS_ID
            ? ''
            : () => {
              requestDeclineRole(user.id).then((data) => {
                console.log(data)
                getUsers()
              })
            }
      }
    ]

    if (user.UserStatus.id !== PENDING_USER_STATUS_ID) {
      dropdownItems.shift()
    }

    return {
      lastName: `${capitalizeString(user.lastName)} ${capitalizeString(user.firstName)}`,
      organisation: `${capitalizeString(user.organisation)}`,
      country: capitalizeString(user.Country.name),
      role: <>{renderRoleIconName(user.Role.name)}</>,
      userStatus: (
        <>
          {renderStatusIcon(user.UserStatus.name)}
          {capitalizeString(user.UserStatus.name)}
        </>
      ),
      // eslint-disable-next-line no-magic-numbers
      lastLogin: <>{(user.lastLogin)?.substring(0, 10).split('-').reverse().join('/')}</>,
      action: <ActionsMenu dropdownItems={dropdownItems} />
    }
  })
}

export const makeUserColumns = (sorting, setSorting) => {
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }

  const sortByLastName = () => {
    sortFunction('lastName')
  }

  const sortByCountry = () => {
    sortFunction('country')
  }

  const sortByRole = () => {
    sortFunction('role')
  }

  const sortByUserStatus = () => {
    sortFunction('userStatus')
  }

  const sortByLastLogin = () => {
    sortFunction('lastLogin')
  }

  return [
    {
      id: 'lastName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="name" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'lastName'}
              onChange={sortByLastName}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'lastName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'organisation',
      header: <FormattedMessage id="organisation" />,
      accessorKey: 'organisation',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'country',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="country" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'country'}
              onChange={sortByCountry}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'country',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'role',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="role" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'role'}
              onChange={sortByRole}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'role',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'userStatus',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="userStatus" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'userStatus'}
              onChange={sortByUserStatus}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'userStatus',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'lastLogin',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="lastLogin" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'lastLogin'}
              onChange={sortByLastLogin}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'lastLogin',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'action',
      header: <FormattedMessage id="actions" />,
      accessorKey: 'action',
      cell: ({ getValue }) => getValue()
    }
  ]
}
